import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/taskBtn.png'


const _hoisted_1 = { class: "task_change" }
const _hoisted_2 = { class: "task_change_name" }
const _hoisted_3 = {
  key: 0,
  class: "task_title"
}
const _hoisted_4 = {
  key: 1,
  class: "task_title"
}
const _hoisted_5 = { class: "task_num" }
const _hoisted_6 = { class: "task_button" }
const _hoisted_7 = { class: "task_list" }
const _hoisted_8 = {
  key: 3,
  class: "task_last_list"
}

import { ref, watch } from 'vue'
import { getTrainingList, getTrainingTask, getTrainingUpdate } from '@/api/requests/TrainingRequests'
import { useRouter, useRoute } from 'vue-router'
import { formatLang } from '@/utils/format'
import { useTaskStore } from '@/stores/task'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { showToast, FloatingBubble } from 'vant'
import { formatUnlockTime, getTaskUnlockTime, isTaskTimeLocked, TaskUnlockConfig } from '@/utils/taskLock'


export default /*@__PURE__*/_defineComponent({
  __name: 'TaskSwitch',
  setup(__props) {

const { t } = useI18n()
const taskStore = useTaskStore()
const { showTaskSwitch } = storeToRefs(taskStore)
const route = useRoute()
const router = useRouter()
const { availWidth, availHeight } = window.screen
const offset = ref({ x: availWidth - 72, y: availHeight - 250 })
const trainingTaskType = ref(route.query?.taskType)
const trainingId = ref(route.query?.trainingId)
const trainingTaskId = ref(route.query?.taskId)
const globalIndex = ref(route.query?.globalIndex)

const selectedTask = ref(true)
const isDrawerOpen = ref(false)
const trainingTaskList = ref()
const currentTaskIndex = ref(null)
const taskStatus = ref()
const isLastTask = ref(false)
// const { availWidth, availHeight } = window.screen
// const offset = ref({ x: availWidth - 60, y: availHeight - 142 })

const openDrawer = () => {
  selectedTask.value = false
  isDrawerOpen.value = true
}

const trainingUnlockCache = ref<{ trainingId: unknown; config: TaskUnlockConfig; stages: any[] } | null>(null)

const getTrainingUnlockData = async () => {
  if (trainingUnlockCache.value?.trainingId === trainingId.value) return trainingUnlockCache.value
  try {
    const { data, code } = await getTrainingList({ id: trainingId.value as string })
    if (code === 1 && data) {
      trainingUnlockCache.value = {
        trainingId: trainingId.value,
        config: {
          unlockMode: data.unlockMode,
          unlockUnit: data.unlockUnit,
          modeType: data.modeType,
          startStudyTime: data.startStudyTime,
          intervalDays: data.intervalDays
        },
        stages: data.trainingStages || []
      }
    }
  } catch (err) {
    console.log(err)
  }
  return trainingUnlockCache.value
}

const getNextTaskUnlockTime = async (nextTask: any): Promise<string> => {
  const unlockData = await getTrainingUnlockData()
  if (!unlockData) return ''
  const stage = unlockData.stages.find((s: any) => String(s.id) === String(nextTask.trainingStageId))
  if (!isTaskTimeLocked(nextTask, stage, unlockData.config)) return ''
  return formatUnlockTime(getTaskUnlockTime(nextTask, stage, unlockData.config))
}

const getTrainingTaskFunc = async () => {
  if (trainingId.value && globalIndex.value != null) {
    const { data, code } = await getTrainingTask({ trainingId: trainingId.value })
    if (code === 1) {
      trainingTaskList.value = data
      if (trainingTaskList.value) {
        trainingTaskList.value.forEach((element, index) => {
          if (Number(globalIndex.value) === element.globalIndex) {
            currentTaskIndex.value = index
            taskStatus.value = element.status
            // 最后一个任务
            if (index + 1 === trainingTaskList.value.length) {
              isLastTask.value = true
            }
          }
        })
      }
      // console.log(currentTaskIndex.value, trainingTaskList.value.length, '已是最后一个任务')
    }
  }
}

watch(
  () => [route.query?.globalIndex, route.query?.taskType, route.query?.trainingId, route.query?.taskId],
  (newVal) => {
    isDrawerOpen.value = false
    globalIndex.value = newVal[0]
    trainingTaskType.value = newVal[1]
    trainingId.value = newVal[2]
    trainingTaskId.value = newVal[3]
    isLastTask.value = false
    getTrainingTaskFunc()
  },
  { immediate: true }
)

const closeDrawer = () => {
  selectedTask.value = true
  isDrawerOpen.value = false
}

const goBack = () => {
  router.go(-1)
}

const switchToNextTask = async () => {
  await getTrainingTaskFunc()

  if (trainingTaskList.value) {
    const nextTaskIndex = Number(currentTaskIndex.value) + 1
    if (nextTaskIndex < trainingTaskList.value.length) {
      const nextTask = trainingTaskList.value[nextTaskIndex]
      // 时间解锁模式：下一个任务/所在阶段未解锁，提示解锁时间
      const nextUnlockTime = await getNextTaskUnlockTime(nextTask)
      if (nextUnlockTime) {
        showToast(formatLang(t('app_task_unlock_time'), [nextUnlockTime]))
        return
      }
      // console.log('相同的index', nextTask, nextTask.taskType)
      // 当前任务未完成，下个任务未解锁，提示请先完成本任务
      if (trainingTaskList.value[nextTaskIndex].lockStatus === 1) {
        showToast(t('app_current_task_first'))
        return
      }
      /* 已删除课程 不显示悬浮任务 */
      if (nextTask.isRefDeleted && nextTask.isRefDeleted === 1) {
        selectedTask.value = false
      }

      if (nextTask.taskType === 1 || nextTask.taskType === 2) {
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'courseDetail',
          query: {
            id: nextTask.taskId,
            endingType: 0,
            channel: 3,
            courseType: nextTask.taskType === 1 ? 'course' : 'courseWare',
            trainingId: nextTask.trainingId,
            globalIndex: nextTask.globalIndex
          }
        })
      } else if (nextTask.taskType === 3) {
        // 考试
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'ExamInfo',
          query: { examId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      } else if (nextTask.taskType === 4) {
        // 调查
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        // 调查
        if (nextTask.status === 200) {
          router.replace({
            name: 'surveyDetails',
            query: {
              investigationId: nextTask.taskId,
              trainingId: nextTask.trainingId,
              globalIndex: nextTask.globalIndex
            }
          })
        } else {
          router.replace({
            name: 'surveyInfo',
            query: {
              investigationId: nextTask.taskId,
              trainingId: nextTask.trainingId,
              globalIndex: nextTask.globalIndex
            }
          })
        }
      } else if (nextTask.taskType === 5) {
        // 作业未开始
        // 作业已结束
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'TrainingHomework',
          query: { taskId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      } else if (nextTask.taskType === 6) {
        // 签到
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'SignTask',
          query: { taskId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      } else if (nextTask.taskType === 7) {
        // 链接
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'LinkTask',
          query: { taskId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      } else if (nextTask.taskType === 8) {
        // 练习
        router.replace({
          name: 'ExamPractiseInfo',
          query: {
            practiseId: nextTask.taskId,
            trainingId: nextTask.trainingId,
            globalIndex: nextTask.globalIndex
          }
        })
      } else if (nextTask.taskType === 9) {
        router.replace({
          name: 'faceDetail',
          query: {
            faceId: nextTask.taskId,
            trainingId: nextTask.trainingId,
            globalIndex: nextTask.globalIndex
          }
        })
      } else if (nextTask.taskType === 10) {
        // 其他
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'OtherTraining',
          query: { taskId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      } else if (nextTask.taskType === 11) {
        // 签署任务
        if (nextTask.startTime && nextTask.endTime) {
          const now = Date.now()
          const start = new Date(nextTask.startTime).getTime()
          const end = new Date(nextTask.endTime).getTime()

          if (now < start) {
            // 未开始
            showToast(formatLang(t('app_sign_task_not_start'), [nextTask.startTime, nextTask.endTime]))
            return
          } else if (now > end) {
            // 已结束
            showToast(formatLang(t('app_sign_task_ended'), [nextTask.startTime, nextTask.endTime]))
            return
          }
        }
        getTrainingUpdate({
          trainingId: nextTask.trainingId,
          trainingTaskId: nextTask.taskId
        })
        router.replace({
          name: 'signDetail',
          query: { trainConfirmId: nextTask.taskId, trainingId: nextTask.trainingId, globalIndex: nextTask.globalIndex }
        })
      }
      selectedTask.value = true
      isDrawerOpen.value = false
      currentTaskIndex.value = nextTaskIndex
    } else {
      // 最后一个任务
      showToast(t('app_last_task'))
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_unref(showTaskSwitch))
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "body"
      }, [
        _createVNode(_unref(FloatingBubble), {
          axis: "xy",
          magnetic: "x",
          offset: offset.value,
          "onUpdate:offset": _cache[0] || (_cache[0] = ($event: any) => ((offset).value = $event)),
          onClick: openDrawer
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "task-btn" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                srcset: ""
              })
            ], -1)
          ]))]),
          _: 1
        }, 8, ["offset"]),
        _createVNode(_component_van_popup, {
          show: isDrawerOpen.value,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((isDrawerOpen).value = $event)),
          position: "bottom",
          round: "",
          "lock-scroll": "",
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (taskStatus.value === 200)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "iconfont icon-icon_wode_wodepeixun_wancheng sucessful_icon" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('app_pass_task')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "iconfont icon-icon_ketang_kechengbao_weikaishi studying_icon" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.$t('app_in_task')), 1)
                    ])),
                _createElementVNode("div", { onClick: closeDrawer }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "iconfont icon-icon_wode_wodepeixun_guanbi close_icon" }, null, -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatLang)(_unref(t)('app_currtask_index'), [Number(currentTaskIndex.value) + 1, trainingTaskList.value.length])), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", { onClick: goBack }, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "task_back" }, [
                    _createElementVNode("i", { class: "iconfont icon-icon_wode_wodepeixun_fanhuiliebiao1 back_icon" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('app_return_to_tasklist')), 1)
                ]),
                _createElementVNode("div", null, [
                  (!isLastTask.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "next_task",
                        onClick: switchToNextTask
                      }, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "iconfont icon-icon_wode_wodepeixun_xiayirenwu next_icon" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (isLastTask.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "last_task",
                        onClick: switchToNextTask
                      }, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "iconfont icon-icon_wode_wodepeixun_xiayirenwu next_icon" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (!isLastTask.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "task_list",
                        onClick: switchToNextTask
                      }, _toDisplayString(_ctx.$t('app_next_task')), 1))
                    : _createCommentVNode("", true),
                  (isLastTask.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('app_last_task')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}
}

})